import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";
import ValueProps from "@/components/ValueProps";
import ParticipantExperience from "@/components/ParticipantExperience";

export default function Home() {
  return (
    <>
      <Nav />
      <main id="top">
        <Hero />
        <Marquee />
        <ValueProps />
        <ParticipantExperience />
        <section className="cta-band">
          <div className="wrap cta-in">
            <Reveal>
              <div className="kicker">Applications open</div>
              <h2 className="title">Ready to step into the arena?</h2>
              <ThemeTag />
              <p className="intro">
                100 seats. One focused day at Aurora Conference Centre, Osogbo.
                Explore the lab, the playbook and
                the team — then make your case.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <Link className="btn cta-btn" to="/apply" data-testid="home-cta-apply">Apply for a Seat →</Link>
            </Reveal>
          </div>
        </section>
        <Faq />
      </main>
      <Footer />
    </>
  );
}
